import { CTA, styled } from "@vw-marketing/us-components";

export const StyledLayerHeader: any = styled.div<{ hasGoBack?: boolean }>`
  align-items: center;
  display: flex;
  width: stretch;
  ${({ hasGoBack, theme }) => hasGoBack
    ? `gap: ${theme.size.static250};`
    : 'justify-content: space-between;'
  }

  div {
    margin: 0px;
  }
`;

export const StyledLeftArrowCTA = styled(CTA)`
  width: 24px;
`;